import { Phone, Mail, ShieldCheck, Clock, MapPin } from "lucide-react";
import { Reveal } from "../Reveal";
import { BRAND } from "../../data/site";

const ContactRow = ({ href, testid, icon: Icon, label, value }) => (
  <a href={href} data-testid={testid} className="flex items-center gap-4 group">
    <span className="w-11 h-11 rounded-xl bg-[#0A0A0A] text-[#FF6B00] flex items-center justify-center group-hover:bg-[#FF2A2A] group-hover:text-white transition-colors duration-200">
      <Icon size={18} />
    </span>
    <span>
      <span className="block font-tech text-[10px] uppercase tracking-[0.2em] text-zinc-500">{label}</span>
      <span className="font-sub font-bold text-lg break-all">{value}</span>
    </span>
  </a>
);

const PERKS = [
  { icon: ShieldCheck, text: "Clear, itemised pricing — zero hidden fees" },
  { icon: Clock, text: "Response within one business day" },
  { icon: MapPin, text: "Melbourne & surrounding areas" },
];

export const QuoteSidebar = () => (
  <Reveal className="lg:col-span-2">
    <div className="font-tech text-xs uppercase tracking-[0.25em] text-[#FF2A2A] font-semibold mb-4">
      FREE QUOTE — NO OBLIGATION
    </div>
    <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold uppercase tracking-tight leading-[0.95]">
      Get a free <span className="text-gradient">quote</span>
    </h2>
    <p className="mt-5 text-zinc-600 text-sm sm:text-base leading-relaxed">
      Send us your project details and photos for a free quotation.
    </p>

    <div className="mt-9 flex flex-col gap-4">
      <ContactRow href={BRAND.phoneHref} testid="quote-phone-link" icon={Phone} label="Call the studio" value={BRAND.phone} />
      <ContactRow href={BRAND.emailHref} testid="quote-email-link" icon={Mail} label="Email us" value={BRAND.email} />
    </div>

    <div className="mt-9 flex flex-col gap-3 text-sm text-zinc-600">
      {PERKS.map(({ icon: Icon, text }) => (
        <div key={text} className="flex items-center gap-3"><Icon size={16} className="text-[#FF2A2A]" /> {text}</div>
      ))}
    </div>
  </Reveal>
);
